import {
  Stack,
  Modal,
  Typography,
  Button,
  Box,
  List,
  ListItem,
  ListItemText,
} from "@mui/material";
import React from "react";
import Error_info_icon from "../../../assets/images/Icons/ic_info.svg";

const style = {
  position: "absolute",
  top: "65%",
  left: "50%",
  transform: "translate(-50%, -100%)",
  width: 550,
  bgcolor: "background.paper",
  boxShadow: 24,
  borderRadius: "16px",
  outline: "none",
  p: "16px",
};

export const ProductionChartErrorMessageDialog = (props) => {
  const { open, handleClose, state } = props;

  const AlertHandleClose = () => {
    handleClose(false);
  };

  return (
    <Modal open={open}>
      <Box sx={style}>
        <Stack
          direction="row"
          gap="8px"
          alignItems="center"
          lineHeight="34.2px"
        >
          <img
            src={Error_info_icon}
            alt="info"
            style={{ width: "30px", height: "30px" }}
          />

          <Typography
            sx={{
              fontWeight: "600",
              fontSize: "25px",
            }}
          >
            Last Regeneration Failed
          </Typography>
        </Stack>

        <Stack px="8px" pt="8px">
          <Typography fontWeight={400} fontSize="16px" color="#1C1C1C">
            Last regeneration has failed because the following batches have
            exceeded its bowl capacity.
          </Typography>

          <List sx={{ pb: "8px" }}>
            {state?.map((item, index) => (
              <ListItem
                key={index}
                sx={{
                  p: 0,
                  display: "list-item",
                  listStyleType: "disc",
                  "& .MuiListItemText-root": {
                    margin: 0,
                  },
                }}
              >
                <ListItemText
                  primary={`${item.name} (Bowl Capacity - ${
                    item.capacity
                  }${" "}kg)`}
                  primaryTypographyProps={{
                    fontSize: "16px",
                    fontWeight: 400,
                    color: "#1C1C1C",
                  }}
                />
              </ListItem>
            ))}
          </List>
        </Stack>

        <Stack direction="row" justifyContent="flex-end" mt="12px">
          <Button onClick={AlertHandleClose} variant="outlined" color="gray2">
            Close
          </Button>
        </Stack>
      </Box>
    </Modal>
  );
};
